// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__tgnB-","active":"Tab_active__-MRbg","disabled":"Tab_disabled__O+1RJ"};